module.exports = __webpack_public_path__ + "static/symfony-31612fe6a62a6756aa1ba6ecb8a32f96.png";